import styled from 'styled-components';

export const AdvisoryText = styled.p`
  border-top: ${(props) =>
    `1px solid ${props.theme.atlas.semantic.color.type.disabled}`};
  width: 100%;
  margin-top: 24px;
  padding: 24px;
  font-style: italic;
  line-height: 17px;
  color: ${(props) => props.theme.atlas.semantic.color.type.disabled};
  font-size: 11px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.caption.fontFamily};
`;
